(function() {
  const instances = new Map();

  function init(section) {
    const sectionId = section.dataset.sectionId;
    if (instances.has(sectionId)) return;

    // Selecciona solo los elementos dentro de esta sección
    const cards = section.querySelectorAll('.lifebeat-focus-card');
    const panels = section.querySelectorAll('.lifebeat-focus-panel');

    cards.forEach(card => {
      card.addEventListener('click', () => {
        // Quita active solo dentro de esta sección
        cards.forEach(c => c.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));

        card.classList.add('is-active');

        const panel = section.querySelector(
          `[data-panel="${card.dataset.focus}"]`
        );
        if (panel) panel.classList.add('is-active');
      });
    });

    // Marcar el primer card como activo al cargar
    if (cards.length > 0) {
      cards[0].classList.add('is-active');
      const firstPanel = section.querySelector(
        `[data-panel="${cards[0].dataset.focus}"]`
      );
      if (firstPanel) firstPanel.classList.add('is-active');
    }

    instances.set(sectionId, true);
  }

  // Shopify Lazy Load
  document.addEventListener('section:lifebeat-functional-focus:load', (e) => {
    init(e.detail);
  });
})();
